<template>
    <v-card>
        <v-toolbar color="red" dark flat>
            <v-toolbar-title>Costi Aggiuntivi</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="success" rounded @click="openDialog()" v-if="!disabled">
                <v-icon left>add</v-icon>Inserisci Costo Aggiuntivo
            </v-btn>
        </v-toolbar>

        <v-data-table :loading="loading" :headers="headers" :items="addictional_costs" hide-default-footer>
            <template v-if="!disabled" v-slot:item.actions="{ item }">
                <v-btn small icon color="warning" @click="editCost(item)"><v-icon>edit</v-icon></v-btn>
            </template>
            <template v-slot:item.date="{ item }">
                {{ formatDate(item.date) }}
            </template>
            <template v-slot:item.cost="{ item }">
                {{ item.cost | euro }}
            </template>
        </v-data-table>

        <addictional-costs-editor v-model="dialog" :form="form" @save="saveCost" @delete="deleteCost"/>
    </v-card>
</template>

<script>
import AddictionalCostsEditor from './AddictionalCostsEditor.vue';

export default {
    props: {
        value: { required: true, type: Object },
        disabled: { default: false },
        loading: { default: false },
        confirmMessage: { type: String, default() { return trans('common.confirm-delete') } },
        permissions: {type:Array, default:[]}
    },
    data() {
        let addictional_costs = this.value.addictional_costs || [];

        return {
            headers: [
                { text: 'Data', value: 'date' },
                { text: 'Nome', value: 'name' },
                { text: 'Descrizione', value: 'description' },
                { text: 'Costo', value: 'cost' },
                ...(!this.disabled ? [{ text: 'Azioni', value: 'actions', sortable: false }] : [])
            ],
            addictional_costs,
            dialog: false,
            editCostData: null,
            form: {
                project_id: this.value.id,
                name: '',
                description: '',
                cost: '',
                date: ''
            },
        };
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            const [year, month, day] = date.split('-');
            return `${day}/${month}/${year}`;
        },
        openDialog() {
            this.resetForm();
            this.editCostData = null;
            this.dialog = true;
        },
        editCost(item) {
            this.form = { ...item };
            this.editCostData = item;
            this.dialog = true;
        },

        async saveCost() {
            try {
                let response;

                if (this.editCostData) {
                    response = await axios.put(`/projects/project-additional-costs/${this.editCostData.id}`, this.form);
                } else {
                    response = await axios.post('/projects/project-additional-costs', this.form);
                }

                if (response.status === 200 || response.status === 201) {
                    if (this.editCostData) {
                        Object.assign(this.editCostData, response.data);
                    } else {
                        this.addictional_costs.push(response.data);
                    }

                    this.dialog = false;
                    this.$emit('update-addictional-costs', this.addictional_costs);
                }
            } catch (error) {
                console.error('Errore nel salvataggio del costo:', error);
            }
        },
        async deleteCost(id) {
            if (confirm(this.confirmMessage)) {
                try {
                    let response = await axios.delete(`/projects/project-additional-costs/${id}`);

                    if (response.status === 200) {
                        this.addictional_costs = this.addictional_costs.filter(cost => cost.id !== id);
                        this.resetForm();
                        this.dialog = false;
                    }
                    this.$emit('update-addictional-costs', this.addictional_costs);
                } catch (error) {
                    console.error('Errore durante l\'eliminazione del costo:', error);
                }
            }

        },

        resetForm() {
            this.form = {
                project_id: this.value.id,
                name: '',
                description: '',
                cost: '',
                date: ''
            };
        }
    },
    components: {
        AddictionalCostsEditor,
    }
};
</script>
